<template>
  <div class="menu">
    <div class="menu_header">
      <img src="" alt="" class="cancel_button" />
      <img src="" alt="" class="logo" />
    </div>
    <h1>Hello there!</h1>
  </div>
</template>

<script>
export default {
  name: "WebMenu",
};
</script>

<style scoped lang="scss">
.menu {
  width: 28.6vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 4.3vw;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #f3f3f3;
  background: #faf500;
}
</style>
